<template>
  <div class="flex flex-wrap course-structure div-with-loading">
    <h3 class="w-1/2">{{ title }} structure</h3>
    <div v-if="duration" class="ml-auto text-gray" title="Duration is updated after save">Duration: <span class=" font-bold">{{ courseDuration }}</span></div>
    <div class="w-full delete-structure"><vs-button @click="$emit('delete-structure')" class="float-right" size="small" color="danger">Delete structure</vs-button></div>
    <div class="w-full pl-5" v-if="numberOfWaitingVideos">
      <vs-alert color="warning" icon-pack="feather" icon="icon-info" class="mt-5">
        {{ numberOfWaitingVideos }} {{numberOfWaitingVideos === 1 ? 'video' : 'videos'}} in waiting status
      </vs-alert>
    </div>
    <draggable
      class="w-full pl-5 mt-5 list-group-root"
      v-show="isOpen"
      tag="ul"
      v-model="orderContent"
      v-bind="dragOptions"
      group="root"
      filter=".dont-move"
      @start="drag = true"
      @end="drag = false"
    >
      <tree-structure-item
        v-for="(child, index) in content" :key="`${child.name}${index}` || `${child.uuid}${index}`"
        :item="child"
        :index="index"
        :videos="videos"
        :quizzes="quizzes"
        :exercises="exercises"
        :labs="labs"
        :iframes="iframes"
        :courses="courses"
        :groupers="groupers"
        :groupersCanAddLeaf="groupersCanAddLeaf"
        :canEditLeafs="canEditLeafs"
        :posibleLeafs="posibleLeafs"
        :namespace="namespace"
        :searchingRelatedOf="searchingRelatedOf"
        :showLinkToContent="showLinkToContent"
        @open-content="$emit('open-content', $event)"
        @add-group="$emit('add-group', $event)"
        @add-leaf="$emit('add-leaf', $event)"
        @delete-group="$emit('delete-group', $event)"
        @delete-leaf="$emit('delete-leaf', $event)"
        @rename-group="$emit('rename-group', $event)"
      />
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import TreeStructureItem from './TreeStructureItem'
import {secondsToHms} from '@/utils/utils.js'
import { flatten } from "@/utils/utils.js";

export default {
  name: "TreeStructure",
  components: {
    TreeStructureItem,
    draggable
  },
  props: {
    content: Array,
    duration: Number,
    videos: Object,
    quizzes: Object,
    exercises: Object,
    labs: Object,
    iframes: Object,
    courses: Object,
    title: {
      type: String,
      default: () => {
        return 'Course'
      }
    },
    groupers: Array,
    groupersCanAddLeaf: Array,
    canEditLeafs: Boolean,
    posibleLeafs: Array,
    namespace: String,
    searchingRelatedOf: {
      type: Object,
      default: () => {
        return {
          loading: false,
          group: null,
        }
      }
    },
    showLinkToContent: {
      type: Boolean,
      default: () => {
        return false
      }
    },
  },
  data () {
    return {
      localDuration: 0,
      isOpen: true,
      drag: false,
      dragOptions: {
        animation: 200,
        group: 'group',
        disabled: false,
        ghostClass: "ghost"
      }
    }
  },
  computed: {
    courseDuration () {
      return secondsToHms(this.duration)
    },
    orderContent: {
      get() {
        return this.content
      },
      set(value) {
        this.$store.dispatch(`${this.namespace}/updateContentStructure`, {
          item: null,
          newContent: value
        });
      }
    },
    numberOfWaitingVideos () {
      try {
        if (!this.videos) return ''
        let input = JSON.parse(JSON.stringify(this.content));
        const self = this
        let res = input.map(function f(o) {
          return o.content_type === 'video'
            ? self.videos[o.uuid].status
            : o.content && o.content.length
            ? o.content.map(f)
            : [];
        });
        res = flatten(res, true)
        res = res.filter(s =>  s === 'waiting')
        return res.length
      } catch (error) {
        return ''
      }
    }
  },
  watch: {
    'duration': function (newValue) {
      this.localDuration = newValue
    }
  }
}
</script>